export default __webpack_public_path__ + "static/media/im-title-en.2437a7e0.webp";